import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {

  // ===========================
  // 🧠 CHECK USER LOGIN STATUS
  // ===========================
  const user = localStorage.getItem("user");

  // ===========================
  // 🚫 IF USER NOT LOGGED IN
  // ===========================
  if (!user) {

    // redirect user to login page
    return <Navigate to="/login" replace />;
  }

  // ===========================
  // ✅ IF USER LOGGED IN
  // ===========================
  return children;
};

export default ProtectedRoute;